export const MENUS = {
  UNSELECTED: "unselected",
  HOME: "home",
  AI: "ai",
  SETTINGS_HEADER: "settings_header",
  SETTINGS_PERSONAL: "settings_personal",
  SETTINGS_WORKSPACES: "settings_workspaces",
  ALL: "all",
  ASKED: "asked",
  ASKED_ALL: "asked_all",
  MY_COLLECTIONS: "my_collections",
  COLLECTION_ASK: "collection_ask",
  COLLECTION_RESOURCES: "collection_resources",
  COLLECTION_ASKED: "collection_asked",
  COLLECTION_STATS: "collection_stats",
  SNIPPET_MANAGER: "snippet_manager",
  COLLECTION_REPORT_CARD: "collection_report_card",
  CONFIGURE: "configure",
  PERSONA_MANAGER: "persona_manager",
  POLICY_STUDIO: "policy_studio",
};
